import React, { useState, useContext, useEffect, useRef } from "react";
import Button from "./Button";
import SignatureCanvas from "react-signature-canvas";
import { AppContext } from "../context";
import {
  initializeEmail,
  setLog,
  userLogs,
  patLogs,
  setResumeFlowEmail,
  translateText,
  vinCheckDB,
  setHyundaiData,
  signatureUpload,
  setquestionValue,
} from "../context/utils";
import Navbar from "./Navbar";

// import * as Sentry from "@sentry/react";
// import ReactGA from "react-ga4";

let logsbugs = true;

const KarlQuestion = () => {
  const {
    stepCovered,
    setStepCovered,
    setScreen,
    setUserEmail,
    clientId,
    token,
    inspectionId,
    config,
    showAlert,
    setCurrentPage,
    currentPage,
    setStartPing,
  } = useContext(AppContext);

  const land = () => window.innerWidth > window.innerHeight * 1.2;
  const [screenHeight, setScreenHeight] = useState(land() ? false : true);
  const [kiwiCustom, setKiwiCustom] = useState(Object.keys(config).includes("customer-declaration") ? true : false);
  const [questionValue, setQuestionValue] = useState(null);
  const [checkBoxValue, setcheckBoxValue] = useState(false);
  const [disable, setDisable] = useState(true);
  const sigCanvas = useRef(null);
  const [isSigned, setIsSigned] = useState(false);
  const [base64UrlData, setBase64UrlData] = useState("");
  window.onresize = () => {
    setScreenHeight(land() ? false : true);
  };

  const onProceed = () => {
    if (Object.keys(config).includes("customer-declaration") && checkBoxValue) {
      setScreen("success");
      if (Object.keys(config).includes("customer-declaration-signature") && base64UrlData.length > 0) {
        signatureUpload(clientId, inspectionId, base64UrlData);
      }
      return;
    }
    if (questionValue === true) {
      setquestionValue(inspectionId, questionValue);
      setScreen("success");
    }
    if (questionValue === false && checkBoxValue && base64UrlData.length > 0) {
      setScreen("success");
      setquestionValue(inspectionId, questionValue);
      signatureUpload(clientId, inspectionId, base64UrlData);
    }
  };

  const handleEnd = () => {
    // Called when the user finishes a stroke
    if (!sigCanvas.current.isEmpty()) {
      setIsSigned(true);
    }
  };

  const clearSignature = () => {
    if (sigCanvas.current) {
      sigCanvas.current.clear();
    }
    if(Object.keys(config).includes("customer-declaration-signature"))setDisable(true);
    setIsSigned(false);
    setBase64UrlData("");
  };

  const saveSignature = () => {
    const dataURL = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    // console.log("Signature Image:", dataURL);
    setBase64UrlData(dataURL);
    if(Object.keys(config).includes("customer-declaration-signature"))setDisable(false);
    setIsSigned(false);
  };

  useEffect(() => {
    if (!Object.keys(config).includes("customer-declaration")) setDisable(true);
    if (questionValue === true) {
      setDisable(false);
    }
    if (questionValue === false && checkBoxValue && base64UrlData.length > 0) {
      setDisable(false);
    }
  }, [
    setQuestionValue,
    setcheckBoxValue,
    questionValue,
    checkBoxValue,
    base64UrlData,
    setBase64UrlData,
  ]);

  return (
    <div
      className="screen_email"
      style={{
        height: screenHeight ? "100dvh" : "",
        position: screenHeight ? "relative" : "",
        padding: screenHeight ? "0%" : "",
        width: "100dvw",
      }}
    >
      <Navbar />
      <div className="Question" style={Object.keys(config).includes("customer-declaration") ? { height: "unset" } : {}}>
        {kiwiCustom ? (
          <>
            <p>
              <span>
                <input
                  style={{ accentColor: "#005ecb" }}
                  type="checkbox"
                  value={false}
                  checked={checkBoxValue}
                   onClick={() => {
                    if (checkBoxValue === false) {
                      if (Object.keys(config).includes("customer-declaration-signature")) {
                        if(base64UrlData.length > 0)setDisable(false)
                        else setDisable(true);
                      }
                      else setDisable(false);
                    }
                    else setDisable(true);
                    setcheckBoxValue(checkBoxValue === false ? true : false);
                  }}
                />
              </span>
              {Object.keys(config).includes("customer-declaration-text") ? config["customer-declaration-text"] : "I/We confirm that the vehicle was inspected in my/our presence or through my/our authorised representative. The vehicle details, existing damages, and inspection photographs/videos are true and complete, with no material facts concealed. I/We agree that any pre-existing damages visible in the inspection photographs/videos shall be excluded from claim during the policy period. I/We confirm that the inspected vehicle is the same vehicle proposed for insurance and that no claim shall be payable if found otherwise. I/We also confirm that no third party injury or death has occurred prior to inspection, and that non disclosure of material facts may result in claim denial and legal action."}
            </p>
            {Object.keys(config).includes("customer-declaration-signature") && (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {base64UrlData.length > 0 ? (
                  <>
                    <p style={{ fontWeight: "600" }}>{Object.keys(config["customer-declaration-signature"]).includes("customer-declaration-FTER-signature-text") ? config["customer-declaration-signature"]["customer-declaration-FTER-signature-text"] : "Your signature"}</p>
                    <img
                      style={{ width: window.innerWidth - 40, height: 200 }}
                      src={base64UrlData}
                    />
                  </>
                ) : (
                  <>
                    <p style={{ fontWeight: "600" }}>{Object.keys(config["customer-declaration-signature"]).includes("customer-declaration-signature-text") ? config["customer-declaration-signature"]["customer-declaration-signature-text"] : "Do your signature"}</p>
                    <SignatureCanvas
                      ref={sigCanvas}
                      penColor="black"
                      onEnd={handleEnd}
                      canvasProps={{
                        width: window.innerWidth - 40,
                        height: 200,
                        className: "signatureCanvas",
                        style: {
                          border: "2px solid black",
                          borderRadius: "8px",
                          background: "#fff",
                        },
                      }}
                    />
                  </>
                )}
                <div
                  style={{
                    marginTop: "10px",
                    width: "100dvw",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                  }}
                >
                  <button
                    style={{
                      height: "30px",
                      width: "100px",
                      backgroundColor: "#005ecb",
                      color: "white",
                      border: "none",
                      borderRadius: "2px",
                    }}
                    onClick={clearSignature}
                  >
                    {Object.keys(config["customer-declaration-signature"]).includes("customer-declaration-signature-clear-text") ? config["customer-declaration-signature"]["customer-declaration-signature-clear-text"] : "Clear"}
                  </button>
                  {isSigned && (
                    <button
                      style={{
                        height: "30px",
                        width: "100px",
                        backgroundColor: "#005ecb",
                        color: "white",
                        border: "none",
                        borderRadius: "2px",
                      }}
                      onClick={saveSignature}
                    >
                      {Object.keys(config["customer-declaration-signature"]).includes("customer-declaration-signature-save-text") ? config["customer-declaration-signature"]["customer-declaration-signature-save-text"] : "Save"}
                    </button>
                  )}
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <p>
              Is the vehicle completely empty of all items in the cab &
              trunk/truck-bed? As an exception to this, paperwork in the glovebox
              (registration, proof of insurance) as well as child car seats in the
              passenger area & spare tire are permitted.
            </p>
            <div className="label-div">
              <input
                style={{ accentColor: "#005ecb" }}
                type="radio"
                value={true}
                checked={questionValue === true}
                onClick={() => {
                  setQuestionValue(true);
                }}
              />
              <p>Yes</p>
            </div>
            <div className="label-div">
              <input
                style={{ accentColor: "#005ecb" }}
                type="radio"
                value={false}
                checked={questionValue === false}
                onClick={() => {
                  setQuestionValue(false);
                }}
              />
              <p>No</p>
            </div>
            {questionValue === false && (
              <>
                <p>
                  It is recommended that the vehicle arrives empty of all personal
                  items. Items left in the vehicle will not be covered for damage,
                  theft, etc. Items left in the vehicle may cause the shipment to be
                  rejected, resulting in the vehicle shipment being delayed or
                  canceled. There will be no compensation for any delays or
                  cancellations caused by rejected shipments due to items left in
                  the vehicle.
                </p>
                <p>
                  <span>
                    <input
                      style={{ accentColor: "#005ecb" }}
                      type="checkbox"
                      value={false}
                      checked={checkBoxValue}
                      onClick={() => {
                        setcheckBoxValue(checkBoxValue === false ? true : false);
                      }}
                    />
                  </span>
                  I acknowledge that I have been advised to remove all personal
                  items from the vehicle prior to shipment. I understand that U-Haul
                  is not responsible for any loss or damage to items left in the
                  vehicle. I agree to hold U-Haul harmless from any claims, damages,
                  or losses arising from such items, including but not limited to
                  theft, damage to the vehicle interior, or forced entry.
                </p>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {base64UrlData.length > 0 ? (
                    <>
                      <p style={{ fontWeight: "600" }}>Your signature</p>
                      <img
                        style={{ width: window.innerWidth - 40, height: 200 }}
                        src={base64UrlData}
                      />
                    </>
                  ) : (
                    <>
                      <p style={{ fontWeight: "600" }}>Do your signature</p>
                      <SignatureCanvas
                        ref={sigCanvas}
                        penColor="black"
                        onEnd={handleEnd}
                        canvasProps={{
                          width: window.innerWidth - 40,
                          height: 200,
                          className: "signatureCanvas",
                          style: {
                            border: "2px solid black",
                            borderRadius: "8px",
                            background: "#fff",
                          },
                        }}
                      />
                    </>
                  )}
                  <div
                    style={{
                      marginTop: "10px",
                      width: "100dvw",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-around",
                    }}
                  >
                    <button
                      style={{
                        height: "30px",
                        width: "100px",
                        backgroundColor: "#005ecb",
                        color: "white",
                        border: "none",
                        borderRadius: "2px",
                      }}
                      onClick={clearSignature}
                    >
                      Clear
                    </button>
                    {isSigned && (
                      <button
                        style={{
                          height: "30px",
                          width: "100px",
                          backgroundColor: "#005ecb",
                          color: "white",
                          border: "none",
                          borderRadius: "2px",
                        }}
                        onClick={saveSignature}
                      >
                        Save
                      </button>
                    )}
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
      <div
        className="email_btn"
        style={{
          height: screenHeight ? "auto" : "",
          position: screenHeight ? "absolute" : "",
          bottom: screenHeight ? "10px" : "",
          padding: screenHeight ? "0px 2px" : "",
        }}
      >
        <Button
          disabled={disable}
          wide={true}
          onclick={ () => !disable && onProceed()}
          text={config["intro-page"]["btn-text"]}
        />
      </div>
    </div>
  );
};

export default KarlQuestion;
